module.exports = __webpack_public_path__ + "static/media/poster.b3d09a4c.png";